/**
 * URL 文字列からプロトコルとホスト部を削除します。
 *
 * @param url
 * @returns {void | string | *}
 */
export function removeHost(url) {
    if (!url) {
        return '';
    }

    const defaultHostPattern = 'https?:/+[^/]+';
    const host =
        typeof mtappVars.removeHostPattern === 'string' && mtappVars.removeHostPattern ? mtappVars.removeHostPattern : defaultHostPattern;
    const pattern = new RegExp('^' + host + '(.*)');

    return url.replace(pattern, '$1');
}
